module.exports = __webpack_public_path__ + "img/ao.c521746b.svg";